import { JetView } from 'webix-jet';
import { devConfig, countries, profile } from 'config/config';

/**
 * Class representing the FilterTransfersView.
 * @extends JetView
 */
export default class FilterTransfersView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing filters
        const left = {
            margin: 5,
            id: 'a1',
            autoheight: true,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for ID
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('ID'),
                            labelPosition: 'top',
                            placeholder: _('ID'),
                        },
                        {
                            view: 'combo', // Combo for UserCreate
                            name: 'UserCreate',
                            label: "<span class='icon-user'></span>" + _('Usuario Creó'),
                            labelPosition: 'top',
                            container: 'cmb',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed for UserCreate
                                        this.parse(
                                            webix.ajax(devConfig.geturlApi() + 'Agent/SearchAgent?filter=' + text),
                                        );
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo', // Combo for UserReceive
                            name: 'UserReceive',
                            label: "<span class='icon-user'></span>" + _('Usuario Recibió'),
                            labelPosition: 'top',
                            container: 'cmb',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed for UserReceive
                                        this.parse(
                                            webix.ajax(devConfig.geturlApi() + 'Agent/SearchAgent?filter=' + text),
                                        );
                                    },
                                },
                            },
                        },
                        {
                            view: 'text', // Datepicker input
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                    ],
                },
            ],
        };

        // Second left section (currently empty)
        const left2 = {
            margin: 5,
            id: 'a1',
            autoheight: true,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [{ id: 'grav2', gravity: 1 }],
                },
            ],
        };

        // Upper section layout
        const upper_section = {
            height: document.body.offsetWidth < 500 ? 250 : 0,
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Second upper section layout
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 300 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section2 = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'),
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };

        // Button section with Clear and Consult buttons
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect); // Reset country selection
                        $$('Datepicker').setValue(''); // Clear datepicker
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter data
                        this.app.callEvent('transfers:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Main accordion section for filters
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [accordion_section],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                // Additional initialization for small screens can be added here
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
